import { Carrier } from '@hfc/ui-core';
import { PlanResponse } from '@/planList/domain/PlanResponse';
import { SmallBusinessPlanResponse } from '@/planList/domain/SmallBusinessPlanResponse';

interface UseCarrierInfoInterface {
  getCarrierName: (plan: SmallBusinessPlanResponse | PlanResponse) => string,
  getCarrierLogoId: (plan: SmallBusinessPlanResponse | PlanResponse) => string,
  getCarrierFromPlan: (plan: SmallBusinessPlanResponse | PlanResponse) => Carrier,
  getCompanyName: (key: string, value: string) => string,
}

export const useCarrierInfo = (): UseCarrierInfoInterface => {
  const getCarrierName = (plan: SmallBusinessPlanResponse | PlanResponse): string => {
    return plan.sub_carrier?.name ? plan.sub_carrier.name : plan.carrier.name;
  };

  const getCarrierLogoId = (plan: SmallBusinessPlanResponse | PlanResponse): string => {
    return plan.sub_carrier?.code_name ? plan.sub_carrier.code_name : plan.carrier.code_name;
  };

  const getCarrierFromPlan = (plan: SmallBusinessPlanResponse | PlanResponse): Carrier => {
    return plan.sub_carrier ? plan.sub_carrier : plan.carrier;
  };

  const getCompanyName = (key: string, value: string): string => {
    if (key === 'united') {
      return 'United Healthcare';
    }
    if (key === 'kaiser') {
      return 'Kaiser Permanente';
    }

    return value;
  };

  return {
    getCarrierName,
    getCarrierLogoId,
    getCarrierFromPlan,
    getCompanyName
  };
};
